import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import { connect } from 'react-redux';
import { updateDevicesPageBulkViewModal } from 'redux/actions';
import { getSuggestedPolygonName } from 'common/utils/helpers';
import SvgAF, { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import DropModal from 'components/shared/DropModal/DropModal';
import SearchBar from 'components/shared/SearchBar/SearchBar';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { deletePolygonConfirmation } from 'common/utils/constants';
import BlockedLayer from 'components/shared/BlockedLayer/BlockedLayer';
import PolygonDeletionPopup from '../PolygonDeletionPopup/PolygonDeletionPopup';
import PolygonIntersectionPopup from '../PolygonIntersectionPopup/PolygonIntersectionPopup';
import MapControlPopUp from '../../../../MapControlPopUp/MapControlPopUp';
import PolygonCreationPopup from '../PolygonCreationPopup/PolygonCreationPopup';
import Fog from 'components/shared/Fog/Fog';
import classnames from 'classnames';

class DeviceMapOverlay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewOpen: false,
      viewDropped: false,
      selectedView: '',
      searchViewString: ''
    };
  }

  componentWillUnmount() {
    this.props.dispatch(updateDevicesPageBulkViewModal(false));
  }

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  render() {
    const viewOptions = ['Alarms'];
    let viewDropModalHeight = viewOptions.length * 40 + 70;

    let viewDropModalHeader = (
      <div
        className="DeviceMapOverlay_ViewButton"
        data-tip={this.props.dropModals['bulkView'] !== true ? 'Perform view actions on a selection of devices' : null}
      >
        <IconAndText img={IconLoader.icon_view_alarm} hoverImg={IconLoader.icon_view_alarm_hover} text={'View'} />
      </div>
    );

    // UI logic for showing fog
    const isFogShow =
      this.props.polygonOptionsModal.isOpen ||
      this.props.currentIntersectionedPolygons.length > 1 ||
      this.props.isConfirmDeletePolygonPopUpShow;

    return (
      <div className="DeviceMapOverlay">
        {this.props.mapControlPopUp.isOpen && (
          <MapControlPopUp
            stopPolygonEditingShape={this.props.stopPolygonEditingShape}
            close={() => this.props.onMapControlPopUpClickHandler(false)}
            tileProviderName={this.props.tileProviderName}
            changeTileProvider={this.props.changeTileProvider}
            handlerShowPolygonOptionsModal={this.props.handlerShowPolygonOptionsModal}
            selectedDrawingShape={this.props.selectedDrawingShape}
            screenSize={this.props.screenSize}
            isAllowPolygonActivity={this.props.isAllowPolygonActivity}
            changeDrawingShape={this.props.changeDrawingShape}
            searchPolygonsText={this.props.searchPolygonsText}
            setSearchPolygonsText={this.props.setSearchPolygonsText}
            importPolygon={this.props.importPolygon}
            exportPolygon={this.props.exportPolygon}
            toggleDeleteConfirmationModal={this.props.toggleDeleteConfirmationModal}
            setMapActivatedPolygonMode={this.props.setMapActivatedPolygonMode}
          />
        )}
        {isFogShow && <Fog />}
        {this.props.isBlockedLayerShow && <BlockedLayer />}
        <div className="DeviceMapOverlay_TopDiv">
          <div className="DeviceMapOverlay_TopControl">
            {!this.state.viewOpen && (
              <div className="DeviceMapOverlay_ViewButtonContainer">
                <DropModal
                  title={viewDropModalHeader}
                  height={`${viewDropModalHeight}px`}
                  width="225px"
                  name={'bulkView'}
                >
                  <div className="dropViewContainer">
                    <div className="DeviceMapOverlay_ViewDropModal_SearchListContainer">
                      <div className="DeviceMapOverlay_ViewDropModal_SearchBarContainer">
                        <SearchBar
                          searchQuery={(searchViewString) => {
                            this.setState({ searchViewString });
                          }}
                        ></SearchBar>
                      </div>
                      <div className="DeviceMapOverlay_ViewDropModal_ListContainer">
                        <PerfectScrollbar options={{ wheelPropagation: false }}>
                          <ul className="DeviceMapOverlay_ViewDropModal_List">
                            {viewOptions.map((item, idx) => {
                              if (item.toLowerCase().includes(this.state.searchViewString.toLowerCase())) {
                                return (
                                  <li
                                    key={idx}
                                    className="DeviceMapOverlay_ViewDropModal_ListItem"
                                    onClick={() => {
                                      this.setState({
                                        viewOpen: true,
                                        selectedView: item,
                                        searchViewString: '',
                                        viewDropped: false
                                      });
                                      this.props.dispatch(updateDevicesPageBulkViewModal(true));
                                    }}
                                  >
                                    {item}
                                  </li>
                                );
                              } else {
                                return null;
                              }
                            })}
                          </ul>
                        </PerfectScrollbar>
                      </div>
                    </div>
                  </div>
                </DropModal>
              </div>
            )}
            {this.state.viewOpen && (
              <div className="DeviceMapOverlay_ViewButtonContainer">
                <button
                  className="minViewButton"
                  onClick={() => {
                    this.setState({ viewOpen: false, viewDropped: false });
                    this.props.dispatch(updateDevicesPageBulkViewModal(false));
                  }}
                >
                  <img className={'selectIcon'} src={IconLoader.icon_view_alarm} alt={'view icon'} />
                </button>
                <div className="DeviceMapOverlay_ViewBar">
                  <label className="DeviceMapOverlay_ViewBar_ViewLabel">
                    {this.props.size.width >= 565 ? this.state.selectedView : ''}
                  </label>
                  <IconAndText
                    img={IconLoader.icon_alarm_critical}
                    hoverImg={IconLoader.icon_alarm_critical}
                    text={this.props.size.width >= 605 ? 'Critical' : ''}
                    tooltip={'Critical'}
                  />
                  <IconAndText
                    img={IconLoader.icon_alarm_major}
                    hoverImg={IconLoader.icon_alarm_major}
                    text={this.props.size.width >= 640 ? 'Major' : ''}
                    tooltip={'Major'}
                  />
                  <IconAndText
                    img={IconLoader.icon_alarm_minor}
                    hoverImg={IconLoader.icon_alarm_minor}
                    text={this.props.size.width >= 670 ? 'Minor' : ''}
                    tooltip={'Minor'}
                  />
                  <IconAndText
                    img={IconLoader.icon_alarm_warning}
                    hoverImg={IconLoader.icon_alarm_warning}
                    text={this.props.size.width >= 720 ? 'Warning' : ''}
                    tooltip={'Warning'}
                  />
                  <IconAndText
                    img={IconLoader.icon_alarm_info}
                    hoverImg={IconLoader.icon_alarm_info}
                    text={this.props.size.width >= 750 ? 'Info' : ''}
                    tooltip={'Info'}
                  />
                  <IconAndText
                    img={IconLoader.icon_alarm_undefined}
                    hoverImg={IconLoader.icon_alarm_undefined}
                    text={this.props.size.width >= 790 ? 'Undefined' : ''}
                    tooltip={'Undefined'}
                  />
                  <IconAndText
                    img={IconLoader.icon_alarm_noalarm}
                    hoverImg={IconLoader.icon_alarm_noalarm}
                    text={this.props.size.width >= 840 ? 'No alarm' : ''}
                    tooltip={'No alarm'}
                  />

                  <button
                    className="DeviceMapOverlay_ViewBar_CollapseButton"
                    onClick={() => {
                      this.setState({ viewOpen: false, viewDropped: false });
                      this.props.dispatch(updateDevicesPageBulkViewModal(false));
                    }}
                  >
                    <FontAwesomeIcon className="DeviceMapOverlay_ViewBar_viewCollapseIcon" icon="angle-left" />
                  </button>
                </div>
              </div>
            )}
            <div
              id="DeviceMapOverlay_MapControlPopUp_Control"
              className={`DeviceMapOverlay_MapControlPopUp_Control ${this.props.mapControlPopUp.isOpen ? 'show' : ''}`}
              onClick={() => this.props.onMapControlPopUpClickHandler(!this.props.mapControlPopUp.isOpen)}
            >
              <img
                className="DeviceMapOverlay_MapControlPopUp_Control_image"
                src={IconLoader.icon_geofencing}
                alt="Geofencing"
                draggable="false"
              />
              <p className="DeviceMapOverlay_MapControlPopUp_Control_Title">Geofencing</p>
              <img
                className={classnames({
                  DeviceMapOverlay_MapControlPopUp_Control_Arrow: true,
                  Pop_Up_Show: this.props.mapControlPopUp.isOpen
                })}
                src={IconLoader.icon_arrow_map_pop_up}
                alt="Arrow"
                draggable="false"
              />
            </div>
          </div>
          {/* TODO: future feature until further requirement details are defined */}
          {/* <div className="measureController">
            <button className="measureButton" onClick={() => this.props.measureDistanceHandler()}>
              <SvgAF
                img={this.props.isMeasureModeOn ? IconLoader.icon_view_list_on : IconLoader.icon_view_list}
                hover={IconLoader.icon_view_list_hover}
              />
            </button>
          </div> */}
          <div className="zoomController">
            <button className="zoomButton in" onClick={() => this.props.zoomHandler('in')}>
              <SvgAF img={IconLoader.icon_zoom_in} hover={IconLoader.icon_zoom_in_hover} />
            </button>
            <button className="zoomButton out" onClick={() => this.props.zoomHandler('out')}>
              <SvgAF img={IconLoader.icon_zoom_out} hover={IconLoader.icon_zoom_out_hover} />
            </button>
          </div>
        </div>
        <div className="mapSwitchController">
          {this.props.mapSize === 'shrink' && (
            <button className="mapSwitchButton shrink" onClick={() => this.props.mapSizeSwitchHandler('expand')}>
              <SvgAF img={IconLoader.icon_map_expand} hover={IconLoader.icon_map_expand_hover} />
            </button>
          )}
          {this.props.mapSize === 'expand' && (
            <button className="mapSwitchButton expand" onClick={() => this.props.mapSizeSwitchHandler('shrink')}>
              <SvgAF img={IconLoader.icon_map_shrink} hover={IconLoader.icon_map_shrink_hover} />
            </button>
          )}
        </div>
        {this.props.polygonOptionsModal.isOpen && (
          <PolygonCreationPopup
            savePolygon={this.props.savePolygon}
            newPolygonColor={this.props.geometryColor}
            newPolygonName={getSuggestedPolygonName(this.props.polygonList)}
            polygonOptionsModal={this.props.polygonOptionsModal}
            closePolygonOptionsModal={this.props.closePolygonOptionsModal}
          />
        )}
        {this.props.isConfirmDeletePolygonPopUpShow && (
          <PolygonDeletionPopup
            deviceGroupId={this.props.activePolygonId}
            cancelText={deletePolygonConfirmation.cancelText}
            onCancel={() => this.props.toggleDeleteConfirmationModal(false)}
            onConfirm={() => this.props.deletePolygon(this.props.activePolygonId)}
          />
        )}
        {this.props.currentIntersectionedPolygons.length > 1 && (
          <PolygonIntersectionPopup
            currentIntersectionedPolygons={this.props.currentIntersectionedPolygons}
            selectIntersectionPolygon={this.props.selectIntersectionPolygon}
          />
        )}
      </div>
    );
  }
}

export default connect((store) => {
  return {
    mapSize: store.style.mapSize,
    isBlockedLayerShow: store.style.isBlockedLayerShow,
    dropModals: store.ui.sharedPages.dropModals,
    bulkViewModalOpen: store.ui.devicesPage.bulkViewModalOpen
  };
})(DeviceMapOverlay);
